/*
 * Restores Shopify's real cart-add endpoint.
 *
 * This exported theme loads an old obfuscated external script that can overwrite
 * window.routes.cart_add_url after a built-in date check. When that happens the
 * product form intercepts the submit event but sends it to the wrong endpoint,
 * so the Add to cart button appears to do nothing.
 */
(() => {
  'use strict';

  const correctCartAddUrl =
    window.__themeCorrectCartAddUrl ||
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? `${window.Shopify.routes.root}cart/add`
      : '/cart/add');

  const lockCartAddRoute = () => {
    window.routes = window.routes || {};

    try {
      Object.defineProperty(window.routes, 'cart_add_url', {
        configurable: true,
        enumerable: true,
        get() {
          return correctCartAddUrl;
        },
        set() {
          // Ignore stale external scripts attempting to replace the Shopify route.
        },
      });
    } catch (error) {
      window.routes.cart_add_url = correctCartAddUrl;
    }
  };

  lockCartAddRoute();

  document.addEventListener('DOMContentLoaded', lockCartAddRoute, { once: true });

  // Re-assert immediately before any product-form submission or ATC click.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]')) {
        lockCartAddRoute();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('button[name="add"], .main-product-atc, [id^="SectionAtcBtn-"]')) {
        lockCartAddRoute();
      }
    },
    true
  );
})();
